<template>
  <ul class="project-card-list">
    <template v-for="(item, index) in projectList" :key="index">
      <li :style="{cursor:item.id || item.url ? 'pointer':'auto'}" @click="toDetail(item.id,item.url)">
        <img :src="item.image" alt=""/>
        <div class="text-area">
          <span class="cr-name">{{ item.name }}</span>
          <span class="cr-introduce multiple-ellipsis">{{ item.content }}</span>
        </div>
      </li>
    </template>
  </ul>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  projectList: Array
})
const router = useRouter()

function toDetail (id, url) {
  if (url) {
    window.open(url)
    return
  }
  id && router.push({
    path: '/crDetail/' + id
  })
}
</script>

<style lang="scss">
.project-card-list {
  display: flex;
  justify-content: space-between;

  li {
    width: 332px;
    height: 511px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
  }

  li img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-image: radial-gradient(#5f5e5e, #868686, #cbcbcb);;
  }

  .text-area {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    right: 0;
    //height: 80px;
    background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    padding: 0 0 20px 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .cr-name {
      font-size: 36px;
      font-weight: 600;
      line-height: 52px;
      color: white;
      font-family: 'NotoSerifSC', system-ui;
    }

    .cr-introduce {
      //text-align: center;
      font-size: 20px;
      font-weight: 400;
      line-height: 35px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
